const convertedCentoFeet = (values) => {
  var realFeet = (values * 0.3937) / 12;
  var feet = Math.floor(realFeet);
  var inches = Math.round((realFeet - feet) * 12);
  return feet + "'" + inches + "''";
};

export default convertedCentoFeet;
